import React from "react";
import { createRoot } from "react-dom/client";
import App from "../components/auth/forgot-password/App";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("auth-forgot-password");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <App />
      </>
    );
  }
});
